import { MigrationInterface, QueryRunner, TableColumn } from 'typeorm'

export class AddCulvertTypes1781967989591 implements MigrationInterface {
  // temporary_relations_entity
  public async up(queryRunner: QueryRunner): Promise<void> {
    let relations = await queryRunner.hasTable('temporary_relations_entity')
    if (relations === false) {
      console.log('No relations tables created yet - bail out of migration')
      return
    }

    await queryRunner.addColumn(
      'temporary_relations_entity',
      new TableColumn({
        name: 'culvertTypes',
        type: 'string',
        isNullable: false
      })
    )
  }

  public async down(queryRunner: QueryRunner): Promise<void> {
    await queryRunner.dropColumn('temporary_relations_entity', 'culvertTypes')
  }
}
